import type { Me } from "../lib/auth.ts";

/**
 * Cómo se nombra a quien está dentro, con lo que trae `/me` y nada más.
 *
 * `/me` solo garantiza el `userId`: el nombre, el usuario y el correo pueden
 * venir vacíos, según lo que tenga la cuenta en lala-ms. Por eso cada cosa se
 * busca en orden y lo que falta no se rellena con nada inventado.
 */

/** El nombre a la vista: el completo si lo hay, si no el usuario o el correo. */
export const displayNameOf = (me: Me): string =>
  me.fullName || me.username || me.email;

/** Palabras de las que sacar iniciales: `ana.lopez@x` cuenta como dos. */
const wordsOf = (me: Me): readonly string[] => {
  if (me.fullName !== "") return me.fullName.split(/\s+/);
  const handle = me.username || (me.email.split("@")[0] ?? "");
  return handle.split(/[\s._-]+/);
};

/**
 * Las iniciales del avatar: la primera y la última palabra, o solo la
 * primera si no hay más. Vacío si `/me` no trae con qué: entonces el avatar
 * enseña un icono, no dos letras inventadas.
 */
export const initialsOf = (me: Me): string => {
  const words = wordsOf(me).filter((word) => word !== "");
  const first = words[0];
  if (first === undefined) return "";
  const last = words.length > 1 ? words[words.length - 1] : undefined;
  // `Array.from` y no `[0]`: una letra fuera del plano básico son dos
  // unidades de UTF-16, y cortarla por la mitad pinta un carácter roto.
  const letter = (word: string): string => Array.from(word)[0] ?? "";
  return `${letter(first)}${last === undefined ? "" : letter(last)}`.toLocaleUpperCase(
    "es",
  );
};
